import { GerenciarOcorrenciasService } from 'src/app/services/gerenciar-ocorrencias.service';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { take } from 'rxjs/operators';
import { HttpResponse } from '@angular/common/http';
import { FilenameParser } from '@utils/FilenameParser';
import { FileDownloadService } from '@services/file-download.service';
import { LoadingGenericoComponent } from '../loading-generico/loading-generico.component';
import { UpperCasePipe, DatePipe } from '@angular/common';

@Component({
    selector: 'app-alert-historico-anotacoes-ocorrencias',
    templateUrl: './alert-historico-anotacoes-ocorrencias.component.html',
    styleUrls: ['./alert-historico-anotacoes-ocorrencias.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [LoadingGenericoComponent, UpperCasePipe, DatePipe]
})
export class AlertHistoricoAnotacoesOcorrenciasComponent implements OnInit {

  @Input() showAlertAnotacoesOcorrencias: boolean = true;
  @Input() idOcorrencia: number;
  @Output() alertAnotacoesOcorrencias = new EventEmitter( );

  public idEmpresa : any = localStorage.idEmpresaLogada ;
  public resources: any;
  public loadingGenerico: boolean  = false;
  idArquivo: any;

  constructor( private readonly gerenciarOcorrenciasService : GerenciarOcorrenciasService) { }

  ngOnInit(): void {
    this.getAllHistorico();
  }

  abrirFechar(){
    this.showAlertAnotacoesOcorrencias = false
    this.alertAnotacoesOcorrencias.emit(this.showAlertAnotacoesOcorrencias);
  }

  public getAllHistorico() {
    this.loadingGenerico = true;
    this.gerenciarOcorrenciasService.gethistoricoOcorrencia (this.idOcorrencia, this.idEmpresa)
    .pipe(take(1))
    .subscribe({
      next: (success: any) => {
        console.log(success.response.ocorrencias);
        this.loadingGenerico = false;
        this.resources = success.response.ocorrencias;
        console.log(this.resources);
      },
      error: (error) => {
        this.loadingGenerico = false;
      }
    })
  }

  baixarArquivo(idArquivo:any, nomeArquivo:any){
    this.gerenciarOcorrenciasService.getArquivoOcorrencia(idArquivo)
    .subscribe({
      next: ({ body, headers }: HttpResponse<any>) => {
        const filename = FilenameParser.fromContentDispositionHeader(
          headers.get('content-disposition'),
          nomeArquivo
          );
          FileDownloadService.download([body], filename);
      },
      error: (error: any) => {
      }
    })
  }

  fecharHistoricoAnotacoesOcorrencias() {
    this.showAlertAnotacoesOcorrencias = false;
    this.alertAnotacoesOcorrencias.emit();
  }
}
